<template>
	<v-app id="dashboard" light>
		<Drawer ref="drawer"></Drawer>

		<Toolbar @toggle-drawer="$refs.drawer.drawer = !$refs.drawer.drawer"></Toolbar>

		<transition mode="out-in">
			<v-main>
				<v-container fluid>
					<!-- P-12: aviso permanente cuando el usuario es de solo lectura (viewer). -->
					<v-alert
						v-if="$store.getters.isReadOnly"
						type="info"
						dense
						text
						border="left"
						class="mb-3"
					>
						<v-icon left>mdi-eye-outline</v-icon>
						Modo solo lectura: puedes consultar los datos pero no modificarlos.
					</v-alert>
					<Alert ref="adminAlert" />
					<router-view />
				</v-container>
			</v-main>
		</transition>

		<!-- <Footer /> -->
	</v-app>
</template>

<script>
	import Drawer from "@/components/core/Drawer.vue";
	import Toolbar from "@/components/core/Toolbar.vue";
	import Alert from "@/components/Alert.vue";
	// import Footer from '@/components/core/Footer.vue'

	export default {
		name: "Dashboard",
		components: {
			Drawer,
			Toolbar,
			Alert
			// Footer
		}
	};
</script>

<style lang="scss">
	@import "@/styles/index.scss";
</style>
